var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VcUpsellBlock',{attrs:{"mode":"dialog","image-url":_vm.image,"title-text":_vm.$t('payment.work_order_upgrade.title'),"subtitle-text":_vm.$t('payment.work_order_upgrade.subtitle'),"button-text":_vm.$t('payment.work_order_upgrade.button'),"icon":"$check_circle_fill","bullets-text":_vm.bullets},on:{"buttonClick":_vm.goToUpgrade}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }